import React, { useEffect, useState } from "react";
import useAuth, { authData } from "../../context/AuthProvider";
import { Box, Button, Dialog, DialogContent, IconButton, LinearProgress, Tooltip, Typography } from "@mui/material";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from '@mui/icons-material/Menu';
import { ReactComponent as InboxIcon } from '../../assets/icons/InboxIcon.svg';
import { ReactComponent as FolderPlusIcon } from '../../assets/icons/FolderPlusIcon.svg';
import { ReactComponent as DocumentIcon } from '../../assets/icons/DocumentIcon.svg';
import SearchIcon from '@mui/icons-material/Search';
import { ReactComponent as SettingsIcon } from '../../assets/icons/SettingsIcon.svg';
import { ReactComponent as ArrowCircleIcon } from '../../assets/icons/ArrowCircleIcon.svg';
import { ReactComponent as InfoIcon } from '../../assets/icons/InfoIcon.svg';
import { ReactComponent as ExitIcon } from '../../assets/icons/ExitIcon.svg';
import Swal from "sweetalert2";
import { apiClient } from "../../helper/api";
import { SvgIcon } from '../Icons/SvgIcon';
import { useNavigate } from 'react-router-dom';
import { AppFlags } from "../../helper/config";
import { StateInformationPortalUrl, LicensingPortalUrl } from '../../Constants';
import { AppRoutes } from "../../helper/appRoutes";

var formData = new FormData();
interface Iprops {

  handleClose: () => void,
  Open: boolean,
}
interface ProfilePictureModalProps {
  open: boolean;
  onClose: () => void;
  currentPicture: string;
  onUpdatePicture: (newPicture: string) => void;

}
const ProfilePictureModal: React.FC<ProfilePictureModalProps> = ({
  open,
  onClose,
  currentPicture,
  onUpdatePicture,

}) => {
  const [selectedImage, setSelectedImage] = useState<File | null>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      formData.delete('image');
      formData.append('image', file);
      setSelectedImage(file);
    }
  };

  const [loading, setloading] = useState(false);
  const handleUpload = () => {
    if (selectedImage) {
      setloading(true);
      const objectURL = URL.createObjectURL(selectedImage);
      // onUpdatePicture(objectURL);
      //Simulate server upload
      setTimeout(() => {
        onUpdatePicture(objectURL);
        setloading(false);
      }
        , 6000
      );

    }
  };
  const handleCloseImage = () => {
    setSelectedImage(null);
    formData.delete('image');
    onClose();
  };


  return (
    <Dialog open={open} onClose={onClose} maxWidth='lg'  >

      {loading && <LinearProgress style={{ margin: 2 }} />}
      <DialogContent
        sx={{
          // width: 380,
          // height: 480,
          // bgcolor: "background.paper",
          // boxShadow: 24,
          borderRadius: "25px",
          textAlign: "center",
          outline: "none",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "0px",
          position: "relative",
        }}
      >
        <IconButton
          onClick={handleCloseImage}
          sx={{
            position: "absolute",
            top: -10,
            right: 0,
            color: "#333",
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography
          variant="h5"
          component="h2"
          sx={{ mb: 3, fontWeight: "bold", fontSize: "20px" }}
        >
          Edit Profile Picture
        </Typography>
        <Box
          sx={{
            width: "300px",
            height: "300px",
            borderRadius: "50%",
            border: "4px solid #ddd",
            overflow: "hidden",
            mb: 2,
            position: "relative",
          }}
        >
          <img
            src={selectedImage ? URL.createObjectURL(selectedImage) : currentPicture}
            alt="Current"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
          <IconButton
            component="label"
            sx={{
              position: "absolute",
              bottom: 0,
              right: 0,
              bgcolor: "rgba(0, 0, 0, 0.6)",
              color: "#fff",
              borderRadius: "50%",
              p: 3,
              m: 3,
            }}
          >
            <CameraAltIcon />
            <input
              accept="image/*"
              style={{ display: "none" }}
              id="profile-picture-upload"
              type="file"
              onChange={handleFileChange}
            />
          </IconButton>
        </Box>
        <Box  >
          <div className="d-flex">


            <Button
              variant="contained"
              color="primary"
              onClick={handleUpload}
              className="btn-profile-save me-2 "
            >
              {loading ? "Saving..." : "Save"}
            </Button>
            <div>

            </div>
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleCloseImage}
              className="btn-profile-cancel"
            >
              Cancel
            </Button> </div>
        </Box>
      </DialogContent>

    </Dialog>
  );
};


type PartnerItem = { partnersId: string; customerName: string };

export const CustomerHomeRightNav: React.FC<Iprops> = ({ handleClose, Open }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const token = user?.token;
  const [modalOpen, setModalOpen] = useState(false);

  const [userPartners, setUserPartners] = useState<PartnerItem[]>([]);

  const [isDiligentSearchUser, setIsDiligentSearchUser] = useState<boolean>();
  
  useEffect(() => {
    getIsDiligentSearchUser();
  }, []);

  const getIsDiligentSearchUser = () => {
    setloading(true);
    apiClient("/DiligentSearch/isDiligentSearchUser", {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
    }).then((responseJson) => {
      if (!responseJson) return
      setIsDiligentSearchUser(responseJson.data?.isDiligentSearchUser || false);
    }).finally(() => {
      setloading(false);
    });
  };

  useEffect(() => {
    if (Open) fetchUserPartners();
  }, [Open]);

  const fetchUserPartners = async () => {
    // Fetch partners or any other data if needed when modal opens
    if (!Open) return;

    apiClient(`/Customer/getPartnersList`, {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      })
    })
      .then(responseJson => {
        if (!responseJson) return;

        const fetched: PartnerItem[] = (responseJson.data || [])
          .map((p: any) => ({
            partnersId: String(p.partnersId ?? p.PartnersId ?? ''),
            customerName: p.customerName ?? p.CustomerName ?? ''
          }))
          .filter((p: PartnerItem) => !!p.partnersId);

        const sorted = Object.values(fetched).sort((a, b) => a.customerName.localeCompare(b.customerName, undefined, { sensitivity: 'base' }));
        setUserPartners(sorted);
        console.log('Fetched partners:', sorted);
      })
      .catch(err => console.error('Error fetching partners:', err));

  }

  const handleModalOpen = () => {
    setModalOpen(true);
  };
  const handleExitClick = () => {
    Swal.fire({
      title: 'Log Out',
      text: "Are you sure you want to log out?",
      showCancelButton: true,
      confirmButtonColor: '#02A4E3',
      cancelButtonColor: '#d33',
      customClass: 'logout-popup',
      // iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      iconHtml: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-power" viewBox="0 0 16 16"> \
                      <path d="M7.5 1v7h1V1z"/> \
                      <path d="M3 8.812a5 5 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812"/> \
                    </svg>',
    }).then((result) => {
      if (result.isConfirmed) {
        logout();
        navigate(AppRoutes.login);
        return;
      }
    })
  };


  const handleModalClose = () => {
    setModalOpen(false);
  };
  interface UserData {
    userId: number;

  }
  let userStr: authData | undefined = user;

  const [userProfile, setUserProfile] = useState<string | null>(userStr?.profilePicture ?? "");

  const [loading, setloading] = useState(false);

  const handleUpdatePicture = (newPicture: string) => {

    const initValues: UserData = {
      userId: user?.userId ?? 0,

    };
    formData.append("data", JSON.stringify(initValues))
    console.log("finalData", initValues)
    setloading(true);
    apiClient(`/Users/UpdateProfilePicture`, {

      method: "POST",
      headers: new Headers({
        // "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
      body: formData


    })
      .then((res) => {
        if (!res) return
        if (res.resp == 0) {

          // let userStr : authData | undefined =  localStorage.getItem("user");
          // userStr.profilePicture = res.data;
          console.log("profleurl", res.data);
          console.log("loalstorageData", userStr);


          if (userStr != undefined) {
            userStr.profilePicture = res.data
            localStorage.removeItem("user");
            localStorage.setItem("user", JSON.stringify(userStr));
            setUserProfile(res.data);
          }


          Swal.fire({
            title: "Profile Picture Updated Successfully",
            text: "",
            iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>',
            confirmButtonColor: '#02A4E3',
            confirmButtonText: 'OK',
            customClass: {
              confirmButton: 'btn-radius',
              cancelButton: 'btn-radius',
              popup: 'card-radius'
            }
          })
            .then((result) => {
              formData.delete("data");
              formData.delete("image");
              handleModalClose();
            })
        }
        setloading(false);
      })
      .finally(() => {
        setloading(false);
      });

  };

  const fullName = (user?.userFirstName ?? "") + " " + (user?.userLastName ?? "");

  useEffect(() => {
    const script = document.createElement("script");

    script.src = "/assets/dist/js/myscripts.js";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };

  }, []);

  return (
    <div hidden={Open} className="me-n1 p-4 bg-dm-light nav-wrapper custom-style-nav" >

      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'space-between' }}>

        <Box>
          <div className="d-flex justify-content-between align-items-center">
            <img
              src="/assets/brand/MISC_Brandmark_Primary.png"
              className="align-self-center"
              style={{ width: "34px", height: "35px" }}
              alt="MISC"
            ></img>
            <ul className="ms-auto d-flex mb-0 flex-wrap list-unstyled">
              <li className="px-2">
                <a onClick={handleClose} href="javascript:void(0)">
                  <svg
                    width="31"
                    height="31"
                    viewBox="0 0 31 31"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M23.25 7.75L7.75 23.25M7.75 7.75L23.25 23.25"
                      stroke="white"
                      strokeWidth="2.25"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </a>
              </li>
            </ul>
          </div>

          <div className="d-flex justify-content-center align-items-center round-img-sec">
            <div
              className="profile-circle-img me-2"
              onClick={handleModalOpen}
              style={{
                cursor: "pointer",
                borderRadius: "50%",
                overflow: "hidden",
                width: "70px",
                height: "70px",
              }}
            >
              {user?.profilePicture !== null ? (
                <img
                  src={userProfile ?? ""}
                  // src={userStr.profilePicture}

                  alt="Blob Image"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              ) : (
                <img
                  src="/assets/brand/Screen Shot 2024-03-04 at 5.16 1.png"
                  alt="Avatar"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              )}
            </div>
            <div>
              <p className="round-img-p">
                Hi, <b>{user?.userFirstName}</b>
              </p>
            </div>
          </div>

          <ProfilePictureModal
            open={modalOpen}
            onClose={handleModalClose}
            currentPicture={
              userProfile ||
              "/assets/brand/Screen Shot 2024-03-04 at 5.16 1.png"
            }
            onUpdatePicture={handleUpdatePicture}
          // userFirstName ={fullName}

          />

          {/* <IconButton
            onClick={handleClose}
            sx={{
              ml: 2,
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
          >
            <MenuIcon sx={{ fontSize: 24, color: '#ffffff' }} />
          </IconButton> */}
          <div className="nav-bar-right-sides">
            <ul className="list-unstyled mt-3 navigation">
              {(user?.userRoles.split(",").includes("Client Admin") ||
                user?.userRoles.split(",").includes("Client Processors") ||
                user?.userRoles.split(",").includes("State Reporter")) && (
                  <li className="mb-2">
                    <a
                      href={AppRoutes.inbox}
                      className="px-4 py-3 d-flex text-decoration-none text-white"
                      title="Inbox"
                    >
                      <SvgIcon
                        IconComponent={InboxIcon}
                        size={24}
                        fill="#02A4E3"
                        sx={{ mr: '15px' }}
                      />
                      Inbox
                    </a>
                  </li>
              )}
              {(user?.userRoles.split(",").includes("Client Admin") ||
                user?.userRoles.split(",").includes("Client Processors")) && (
                  <li className="mb-2">
                    <a
                      href={AppRoutes.client.base}
                      className="px-4 py-3 d-flex text-decoration-none text-white"
                      title="Filing Queue"
                    >
                      <SvgIcon
                        IconComponent={FolderPlusIcon}
                        size={24}
                        stroke="#02A4E3"
                        strokeWidth="5"
                        sx={{ mr: '15px' }}
                      />
                      Filing Queue
                    </a>
                  </li>
                )}
              {(user?.userRoles.split(",").includes("Client Admin") ||
                user?.userRoles.split(",").includes("Client Processors")) && (
                  <React.Fragment>
                    {AppFlags.enableNonPremiumEndorsement ? (
                      <li className="mb-2">
                        <a
                          href={AppRoutes.client.nonPremiumEndorsements}
                          className="px-4 py-3 d-block text-decoration-none text-white"
                          title="Non-Premium Endorsements"
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="mr-15"
                          >
                            <path
                              d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zm2 16H8v-2h8zm0-4H8v-2h8zm-3-5V3.5L18.5 9z"
                              stroke="#02A4E3"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M14 2V8H20"
                              stroke="#02A4E3"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          Non-Premium Endorsements
                        </a>
                      </li>
                    ) : (null)
                    }
                  </React.Fragment>
                )}
              {(user?.userRoles.split(",").includes("Client Admin") ||
                user?.userRoles.split(",").includes("State Reporter")) && (
                  <li className="mb-2">
                    <a
                      href={AppRoutes.client.stateReports}
                      className="px-4 py-3 d-flex text-decoration-none text-white"
                      title="State Reports"
                    >
                      <SvgIcon
                        IconComponent={DocumentIcon}
                        size={24}
                        stroke="#02A4E3"
                        strokeWidth="5"
                        fill="none"
                        sx={{ mr: '15px' }}
                      />
                      State Reports
                    </a>
                  </li>
                )}
              {isDiligentSearchUser && (
                <li className="mb-2">
                  <a
                    href={AppRoutes.home.diligentSearchLibrary}
                    className="px-4 py-3 d-flex text-decoration-none text-white"
                    title="Diligent Searches"
                  >
                    <SearchIcon
                      sx={{ fontSize: 24, color: '#02A4E3', mr: '15px' }}
                    />
                    Diligent Searches
                  </a>
                </li>)}
              {(user?.userRoles.split(",").includes("Client Admin")) && (
                  <li className="mb-2">
                    <a
                      href={AppRoutes.client.clientUsers}
                      className="px-4 py-3 d-flex text-decoration-none text-white"
                      title="Settings"
                    >
                      <SvgIcon
                        IconComponent={SettingsIcon}
                        size={24}
                        fill="#02A4E3"
                        sx={{ mr: '15px' }}
                      />
                      Settings
                    </a>
                  </li>
                )}
              {(user?.userRoles.split(",").includes("Customer Admin")
              ) && user?.partnerName === "Intrepid Direct Insurance Agency LLC" && (
                <React.Fragment>
                  <li className="mb-2">
                    <a
                        href={AppRoutes.customerOpenTaxReport}
                        className="px-4 py-3 d-block text-decoration-none text-white"
                        title="OTR Upload"
                    >
                        <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="mr-15"
                      >
                        <path
                          d="M4 15C4 15 5 14 8 14C11 14 13 16 16 16C19 16 20 15 20 15V3C20 3 19 4 16 4C13 4 11 2 8 2C5 2 4 3 4 3V15ZM4 15V22"
                          stroke="#02A4E3"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      OTR Upload
                    </a>
                  </li>
                </React.Fragment>
              )}
            </ul>
          </div>
        </Box>


        <ul className="list-unstyled mt-3 navigation">
          {user?.isLicensingUser ? (
            <li className="mb-2">
              <a
                href={LicensingPortalUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="px-4 py-3 d-flex text-decoration-none text-white"
                title="Go to Licensing Portal"
              >
                <SvgIcon
                  IconComponent={ArrowCircleIcon}
                  size={24}
                  stroke="#02A4E3"
                  strokeWidth="5"
                  sx={{ mr: '15px' }}
                />
                Go to Licensing Portal
              </a>
            </li>
          ) : (
            <li className="mb-2">
              <Tooltip title="To become a Licensing client, please contact licensing@morrisisc.com" arrow placement="right" componentsProps={{ tooltip: { sx: { fontSize: '18px' } } }}>
                <span className="px-4 py-3 d-flex text-decoration-none text-white" style={{ cursor: 'default', opacity: 0.9 }}>
                  <SvgIcon
                    IconComponent={ArrowCircleIcon}
                    size={24}
                    stroke="#02A4E3"
                    strokeWidth="5"
                    sx={{ mr: '15px' }}
                  />
                  How to Become Licensing Client?
                </span>
              </Tooltip>
            </li>
          )}
          {user?.isSIPAccess ? (
            <li className="mb-2">
              <a
                href={StateInformationPortalUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="px-4 py-3 d-flex text-decoration-none text-white"
                title="Go to State Information Portal"
              >
                <SvgIcon
                  IconComponent={InfoIcon}
                  size={24}
                  stroke="#02A4E3"
                  strokeWidth="5"
                  sx={{ mr: '15px' }}
                />
                Go to State Information Portal
              </a>
            </li>
          ) : (
            <li className="mb-2">
              <Tooltip title="To become an SIP subscriber, please contact miscfilings@morrisisc.com" arrow placement="right" componentsProps={{ tooltip: { sx: { fontSize: '18px' } } }}>
                <span className="px-4 py-3 d-flex text-decoration-none text-white" style={{ cursor: 'default', opacity: 0.9 }}>
                  <SvgIcon
                    IconComponent={InfoIcon}
                    size={24}
                    stroke="#02A4E3"
                    strokeWidth="5"
                    sx={{ mr: '15px' }}
                  />
                  How to Become SIP Subscriber?
                </span>
              </Tooltip>
            </li>
          )}
          {/* <li className="mb-2">
            <a
              onClick={handleExitClick}
              className="px-4 py-3 d-flex text-decoration-none text-white"
              style={{ cursor: 'pointer' }}
              title="Exit"
            >
              <SvgIcon
                IconComponent={ExitIcon}
                size={24}
                fill="#02A4E3"
                sx={{ mr: '15px' }}
              />
              Exit
            </a>
          </li> */}
        </ul>
      </Box>
    </div >

  );
};
